import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { programData } from '../../components/Tab/TabData';

import Input from '../../components/TextField/Input';
import Select from '../../components/Select/Select';
import { RadioGroup } from '../../components/CheckboxRadio/Radio';
import { Button, PageControlBtns } from '../../components/Button/Button';

import styled from 'styled-components';
import { handleExpense, handlePhone, numberToKr, validateEmail, validateName, validatePhone, validateStr } from '../../hooks/useValidate';
import { fetchGet, fetchPostWithFiles } from '../../hooks/fetch';
import useFiles from '../../hooks/useFiles';
import { openAlert } from '../../components/Modal/MsgBox';
const EnterForm = styled.div`
	padding-top: 0 !important;
	.enter-group-row .gs-input label,
	.enter-group-row .gs-input .label {
		flex-basis: 120px;
	}
	.enter-group-row .txt-sm {
		font-size: 15px;
	}
	.flex-item {
		display: flex;
		align-items: center;
		gap: 10px;
		width: 100%;
	}
	.flex-item > * {
		flex: 1;
	}
	.date-item .date {
		text-align: center;
	}
	@media (max-width: 600px) {
		.enter-group-row .gs-input {
			flex-direction: column;
			align-items: flex-start;
		}
		.enter-group-row .gs-input label,
		.enter-group-row .gs-input .label {
			flex: 0;
		}
		.date-item .date {
			text-align: left;
		}
		.gs-input:has(.gs-bullet.txt) {
			--gap: 0;
		}
		.gs-input .gs-bullet.txt {
			position: static;
		}
	}
`;

const defaultApplyInfo = {
	applicationDate: "",
	startHour: "09",
	startMinute: "00",
	// 260513
	// useMinute: "THIRTY",
	useMinute: "SIXTY",
	name: "",
	phone: "",
	email: "",
	password: "",
	technologyName: "",
	technologySubjectMain: "",
	technologySubjectSub: "",
	requestDetail: "",
	technologyMerit: "",
	professor: "",
	projectName: "",
	projectTypeCode: "",
	projectStartTime: "",
	projectEndTime: "",
	expense: "",
}

export default function CounselApply() {
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '1대1 특허상담프로그램(S.T.A.R.T.) 신청';

	const location = useLocation();
	const applicationDate = location.state?.applicationDate;
	const [applyInfo, setApplyInfo] = useState({...defaultApplyInfo, applicationDate: applicationDate});
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [files, handleFileChange, deleteFile, toFormData] = useFiles();
	const [techSubjectMain, setTechSubjectMain] = useState([]);
	const [techSubjectSub, setTechSubjectSub] = useState([]);
	const [techDisease, setTechDisease] = useState([]);
	const [codeTaskTypes, setCodeTaskTypes] = useState([]);
	
	const [times, setTimes] = useState([]);
	const hours = Object.keys(times ?? {}).map(Number);
	// 260513
	// const availableDurations = times?.[applyInfo.startHour]?.[applyInfo.startMinute] ?? [];
const availableDurations = times?.[applyInfo.startHour]?.["0"] 
  ?? times?.[applyInfo.startHour]?.["00"] 
  ?? [];

	// 260513
	// const can30 = availableDurations.includes(30);
	const can60 = availableDurations.includes(60);


	const onChangeApplyInfo = (e) => {
		const { name, value } = e.target;
		let val = value;
		if(name === "phone") {
			val = handlePhone(value);
		} else if(name === "expense") {
			val = handleExpense(value);
		}

		// 260513
		// setApplyInfo({
		// 	...applyInfo,
		// 	[name]: val
		// });
		  setApplyInfo({
    ...applyInfo,
    [name]: val,
    ...(name === "startHour" ? { startMinute: "00", useMinute: "SIXTY" } : {})
  });
	}

	const onChangeMain = (e) => {
		const { name, value } = e.target;
		setApplyInfo({
			...applyInfo,
			[name]: value,
			technologySubjectSub: ""
		});

		if(value !== "") {
			getApplyTechSubjects(2, value);
		} else {
			setTechSubjectSub([]);
		}
	}

	function getApplyTechSubjects(level = 1, parentId = "") {
		fetchGet(
			`/counsels/subject?level=${level}&parentId=${parentId}`,
			(json) => {
				if(level === 1) {
					setTechSubjectMain(json.list);
				} else if(level === 2) {
					setTechSubjectSub(json.list);
				}
			}
		)
	}

	function getApplyTechDisease() {
		fetchGet(
			`/counsels/disease`,
			(json) => {
				setTechDisease(json.list)
			}
		)
	}

	function getCodeTaskTypes() {
		fetchGet(
			`/counsels/tasks`,
			(json) => setCodeTaskTypes(json.list)
		)
	}

	function getTimes() {
		fetchGet(
			`/counsels/times?date=${applicationDate}`,
			(json) => setTimes(json.availableTimes)
		)
	}

	function cancel() {
		openAlert(
			`신청을 취소했습니다.`,
			() => window.location.replace("/counsel/schedule")
		)
	}

	const validate = () => {
		return validateStr(applyInfo.applicationDate, "날짜를")
			&& validateStr(applyInfo.useMinute, "이용 시간을")
			&& validateName(applyInfo.name)
			&& validatePhone(applyInfo.phone)
			&& validateEmail(applyInfo.email)
			&& validateStr(applyInfo.password, "비밀번호를")
			&& validateStr(applyInfo.technologyName, "기술명을")
			&& validateStr(applyInfo.requestDetail, "상담요청내용을")
			&& validateStr(applyInfo.technologyMerit, "장점 및 차별성을");
	}

	function submit(e) {
		e.preventDefault();

		if(!validate()) return;
		if (startDate && endDate && endDate < startDate) {
			openAlert("종료일은 시작일보다 이전일 수 없습니다.", () => setEndDate(startDate));
			return;
		}

		fetchPostWithFiles(
			"/counsels",
			"신청",
			toFormData({
				...applyInfo,
				projectStartTime: startDate !== undefined ? startDate.format('YYYY-MM-DD') : null,
				projectEndTime: endDate !== undefined ? endDate.format('YYYY-MM-DD') : null,
			}),
			() => { window.location.replace("/counsel/schedule") }
		)
	}
	
	useEffect(() => {
		getApplyTechSubjects();
		getApplyTechDisease();
		getCodeTaskTypes();
		getTimes();
	}, []);

	useEffect(() => {
		if (!times || hours.length === 0) return;

		const hour = applyInfo.startHour;
		const minute = applyInfo.startMinute;

		// 현재 hour가 없으면 첫 hour로
		if (!times[hour]) {
			const firstHour = hours[0];
			const firstMinute = Number(Object.keys(times[firstHour])[0]);

			setApplyInfo(prev => ({
			...prev,
			startHour: firstHour,
			startMinute: firstMinute,
			// 260513
			// useMinute: 'THIRTY'
			useMinute: 'SIXTY'
			}));
			return;
		}

		// 현재 minute가 없으면 첫 minute로
		if (!times[hour][minute]) {
			const firstMinute = Number(Object.keys(times[hour])[0]);

			setApplyInfo(prev => ({
			...prev,
				startMinute: firstMinute,
			// 260513
				// useMinute: 'THIRTY'
				useMinute: 'SIXTY'
			}));
		}
	}, [times]);

	// 260513
	// useEffect(() => {
	// 	if (!can60 && applyInfo.useMinute === 'SIXTY') {
	// 		setApplyInfo(prev => ({ ...prev, useMinute: 'THIRTY' }));
	// 	}
	// }, [applyInfo.startHour, applyInfo.startMinute]);
	useEffect(() => {
  setApplyInfo(prev => ({ ...prev, useMinute: 'SIXTY' }));
}, [applyInfo.startHour, applyInfo.startMinute]);

	return (
		<main id="program-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={programData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<div className="apply-form-wrap">
							<h2 className="gs-page-sub-title">신청하기</h2>
							<div className="detail-form-con">
								<div className="dv-header">
									<div className="gs-flex center gap-5 wrap fc-vivid-red">
										<div className="gs-bullet asterisk">이미 예약된 시간은 선택할 수 없습니다.</div>
									</div>
								</div>
								<EnterForm className="dv-body">
									<form
									//action=""
									>
										<Input.Group className="enter-group-row">
											<div className="gs-input">
												<div className="label gs-essential">신청 일시</div>
												<div className="date-item flex-item">
													<div className="date">{applicationDate}</div>
													<Select
														id="select-application-hour"
														label="시 선택"
														name="startHour"
														value={applyInfo.startHour}
														onChange={onChangeApplyInfo}
													>
														{Object.keys(times)?.map((hour, i) => (
															<option key={i} value={hour}> {hour}시 </option>
														))}
													</Select>
													{/* 260513
													<Select
														id="select-application-minute"
														label="분 선택"
														name="startMinute"
														value={applyInfo.startMinute}
														onChange={onChangeApplyInfo}
													>
														{
															times?.[applyInfo.startHour] 
															? Object.keys(times[applyInfo.startHour])
																	.map((min, i) => (<option key={i} value={min}>{min.toString().padStart(2, '0')}분</option>))
															: []
														}
													</Select> */}
													<div style={{ minWidth: "80px" }}>
  00분
</div>
												</div>
											</div>
											<div className="gs-input">
												<div className="label gs-essential">이용 시간</div>
												{/* 260513
												 <div>
													<RadioGroup
														id="use-time-radio-buttons-group"
														itemClassName="round"
														name="useMinute"
														ckeckOptions={
															can60 ?
															[
																{ value: 'THIRTY', label: '30분', disabled: !can30 },
																{ value: 'SIXTY', label: '60분', disabled: !can60 },
															]
															:
															[	{ value: 'THIRTY', label: '30분', disabled: !can30 }	]
														}
														checked={applyInfo.useMinute}
														onChange={onChangeApplyInfo}
													/>
												</div> */}
												<div>
													<RadioGroup
  id="use-time-radio-buttons-group"
  itemClassName="round"
  name="useMinute"
  ckeckOptions={[
    { value: 'SIXTY', label: '60분', disabled: !can60 },
  ]}
  checked={applyInfo.useMinute}
  onChange={onChangeApplyInfo}
/>
												</div>
											</div>
											<Input
												id="user-name"
												type="text"
												//placeholder=""
												showLabel
												label="신청자"
												name="name"
												value={applyInfo.name}
												onChange={onChangeApplyInfo}
												maxLength={20}
												essential
											/>
											<Input
												id="user-tel"
												type="tel"
												//placeholder=""
												showLabel
												label="휴대폰 번호"
												name="phone"
												value={applyInfo.phone}
												onChange={onChangeApplyInfo}
												maxLength={13}
												essential
											/>
											<Input
												id="user-email"
												type="email"
												//placeholder=""
												showLabel
												label="이메일"
												name="email"
												maxLength={100}
												value={applyInfo.email}
												onChange={onChangeApplyInfo}
												essential
											/>
											<Input.PasswordEye
												id="user-password"
												showLabel
												label="비밀번호"
												name="password"
												value={applyInfo.password}
												onChange={onChangeApplyInfo}
												maxLength={4}
												essential
											>
												<div className="txt gs-bullet asterisk fc-vivid-red">
													신청 취소 시 필요
												</div>
											</Input.PasswordEye>
										</Input.Group>
										<Input.Group className="enter-group-row">
											<Input
												id="technical-name"
												type="text"
												//placeholder=""
												showLabel
												label="기술명"
												name="technologyName"
												maxLength={30}
												value={applyInfo.technologyName}
												onChange={onChangeApplyInfo}
												essential
											/>
											<div className="gs-input">
												<div className="label">관련기술분야</div>
												<div className="flex-item">
													<Select
														id="select-technical-field-1"
														label="관련기술분야 선택"
														name="technologySubjectMain"
														value={applyInfo.technologySubjectMain}
														onChange={onChangeMain}
													>
														<option value={""}>해당 없음</option>
														{ techSubjectMain !== undefined &&
															techSubjectMain.map((subject, i) => <option key={i} value={subject.uid}>{subject.code} {subject.name}</option>)
														}
													</Select>
													<Select
														id="select-technical-field-2"
														label="관련기술분야 선택"
														name="technologySubjectSub"
														value={applyInfo.technologySubjectSub}
														onChange={onChangeApplyInfo}
													>
														<option value={""}>해당 없음</option>
														{ techSubjectSub !== undefined &&
															techSubjectSub.map((subject, i) => <option key={i} value={subject.uid}>{subject.code} {subject.name}</option>)
														}
													</Select>
												</div>
											</div>
											<div className="gs-input">
												<div className="label">관련질환분야</div>
												<div className="flex-item">
													<Select
														id="select-technical-field-3"
														label="관련질환분야 선택"
														name="technologyDisease"
														value={applyInfo.disease}
														onChange={onChangeApplyInfo}
													>
														<option value={""}>해당 없음</option>
														{ techDisease !== undefined &&
															techDisease.map((disease, i) => <option key={i} value={disease.uid}>{disease.code} {disease.name}</option>)
														}
													</Select>
												</div>
											</div>
											<div className="gs-input">
												<label
													id="details-consultation-label"
													htmlFor="details-consultation"
													className="gs-essential"
												>
													상담요청내용
												</label>
												<textarea
													id="details-consultation"
													aria-labelledby="details-consultation-label"
													className="sm"
													name="requestDetail"
													value={applyInfo.requestDetail}
													onChange={onChangeApplyInfo}
													maxLength={500}
												></textarea>
											</div>
											<div className="gs-input">
												<label
													id="technology-advantage-label"
													htmlFor="technology-advantage"
													className="gs-essential txt-sm"
													>
													연구자가 생각하는 기술의 장점 및 차별성
												</label>
												<textarea
													id="technology-advantage"
													aria-labelledby="technology-advantage-label"
													className="sm"
													name="technologyMerit"
													value={applyInfo.technologyMerit}
													onChange={onChangeApplyInfo}
													maxLength={500}
												></textarea>
											</div>

											<Input
												id="professor-name"
												type="text"
												//placeholder=""
												showLabel
												label="담당교수"
												name="professor"
												value={applyInfo.professor}
												onChange={onChangeApplyInfo}
												maxLength={30}
											/>
											<Input
												id="task-name"
												type="text"
												//placeholder=""
												showLabel
												label="관련과제명"
												name="projectName"
												value={applyInfo.projectName}
												onChange={onChangeApplyInfo}
												maxLength={30}
											/>
											<div className="gs-input">
												<div className="label">과제 분류</div>
												<div className="flex-item">
													<Select
														id="select-technical-field-3"
														label="과제 분류 선택"
														name="projectTypeCode"
														value={applyInfo.projectTypeCode}
														onChange={onChangeApplyInfo}
													>
														{codeTaskTypes === undefined
															? <option value={""}>해당 없음</option>
															: codeTaskTypes?.map((task, i) => <option key={i} value={task.code}>{task.name}</option>)
														}
													</Select>
												</div>
											</div>
											<Input.DatePicker
												startDate={startDate}
												setStartDate={setStartDate}
												endDate={endDate}
												setEndDate={setEndDate}
											>
												<div className="label">과제 기간</div>
											</Input.DatePicker>
											<Input
												id="total-research-expenses"
												type="tel"
												placeholder="천원 단위로 입력"
												showLabel
												label="총연구비"
												name="expense"
												value={applyInfo.expense}
												onChange={onChangeApplyInfo}
												maxLength={20}
											><span style={{ maxWidth: "200px", minWidth: "120px",  }}>{numberToKr(applyInfo.expense * 1000)}</span></Input>

											<div className="gs-file-wrap">
												<div className="label">첨부파일</div>
												<div className="gs-files-con">
													<div className="gs-file-upload">
														<input type="file" accept="" multiple={5} onChange={handleFileChange}/>
														<Button type="button" className="cyan" tabIndex={-1}>파일 업로드</Button>
													</div>
													<ul className="gs-files">
														{files !== undefined && files.map((f, i) => {
															return (
																<li key={i}>
																	<a
																		href={URL.createObjectURL(f)}
																		download={f.name}
																		role="button"
																		className="file gs-underline-item blue"
																	>
																		<span className="line">{f.name}</span>
																	</a>
																	<div className="controls">
																		<Button type="button" className="remove" title="삭제" onClick={() => deleteFile(i)}>
																			<span className="sr-only">삭제</span>
																		</Button>
																	</div>
																</li>
															);
														})}
													</ul>
												</div>
											</div>
										</Input.Group>
									</form>
								</EnterForm>
							</div>
						</div>
					</div>

					<PageControlBtns>
						<Button type="button" className="white" onClick={cancel}>취소하기</Button>
						<Button type="button" onClick={submit}>신청하기</Button>
					</PageControlBtns>
				</div>
			</Container>
		</main>
	);
}
